import { isEmpty } from 'lodash';

import {
    REQUEST_FIND_ACTIVE_CONTEST,
    RECEIVE_FIND_ACTIVE_CONTEST,
    FAILURE_FIND_ACTIVE_CONTEST,
    REQUEST_SUBMIT_GIVEAWAY_PARTICIPATION,
    SUCCESS_SUBMIT_GIVEAWAY_PARTICIPATION,
    FAILURE_SUBMIT_GIVEAWAY_PARTICIPATION,
    RESET_FORM_SUBMIT_GIVEAWAY_PARTICIPATION,
    REQUEST_IS_USER_REGISTERED_TO_CONTEST,
    RECEIVE_IS_USER_REGISTERED_TO_CONTEST,
    FAILURE_IS_USER_REGISTERED_TO_CONTEST
} from './constants';
import { HTTP_METHOD_GET, HTTP_METHOD_POST } from '../../constants/httpMethod';

import { CALL_API } from '../../middlewares/api';

import { makeActionCreator } from '../../utils/actionsUtils';

export const ERROR_FORMDATA_EMPTY = 'formData param must not be empty or null or undefined !';

export const reset = makeActionCreator(RESET_FORM_SUBMIT_GIVEAWAY_PARTICIPATION);

const shouldFetchContest = state => {
    const contest = state.giveaway.contest;
    const fetching = state.account.contestFetching;

    if (fetching) {
        return false;
    } else if (isEmpty(contest)) {
        return true;
    } else {
        return false;
    }
};

export function fetchContestIfNeeded() {
    return {
        [CALL_API]: {
            endpoint: '/giveaway',
            method: HTTP_METHOD_GET,
            types: [
                REQUEST_FIND_ACTIVE_CONTEST,
                RECEIVE_FIND_ACTIVE_CONTEST,
                FAILURE_FIND_ACTIVE_CONTEST
            ],
            shouldCallAPI: state => shouldFetchContest(state)
        }
    };
}

export function sendGiveawayParticipationRequest(formData, callback) {
    if (isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }
    return {
        [CALL_API]: {
            endpoint: '/giveaway/register',
            method: HTTP_METHOD_POST,
            body: formData,
            types: [
                REQUEST_SUBMIT_GIVEAWAY_PARTICIPATION,
                SUCCESS_SUBMIT_GIVEAWAY_PARTICIPATION,
                FAILURE_SUBMIT_GIVEAWAY_PARTICIPATION
            ],
            authenticated: true,
            successCallback: (response, dispatch) => {
                if (callback) {
                    callback();
                }
            }
        }
    };
}

export function isUserRegisteredToContest(contestId) {
    return {
        [CALL_API]: {
            endpoint: '/giveaway/user/registered?contestId=' + contestId,
            method: HTTP_METHOD_GET,
            types: [
                REQUEST_IS_USER_REGISTERED_TO_CONTEST,
                RECEIVE_IS_USER_REGISTERED_TO_CONTEST,
                FAILURE_IS_USER_REGISTERED_TO_CONTEST
            ],
            authenticated: true
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/giveaway/actions.js